import { createActionsHook, StoreActionApi } from 'react-sweet-state';

import {
  createDataHook,
  createRestStore,
  getAxiosInstance,
  RestStoreState,
} from '@intelliarts/ia-react-template';

import { Employee } from '../../Employee/models/Employee';
import { EmployeeView } from '../../Employee/models/EmployeeView';
import { employeesMapper } from '../../Employee/store/employeesStore';

const actionConfig = { resourcePath: '/employees' };

type AssigneesState = RestStoreState<EmployeeView>;

export const assigneesActions = {
  loadAssignees: () => async ({ setState }: StoreActionApi<AssigneesState>) => {
    setState({ isLoading: true });
    try {
      const axios = getAxiosInstance();
      const [hrEmployees, recruitEmployees] = (await Promise.all([
        axios.get('/employees', { params: { projectName: 'HR' } }),
        axios.get('/employees', { params: { projectName: 'Recruitment' } }),
      ])) as unknown as [Employee[], Employee[]];
      const combined = [...hrEmployees, ...recruitEmployees];
      const uniqueMap = new Map(combined.map((u) => [u.id, u]));
      const data = Array.from(uniqueMap.values()).map((u) => employeesMapper.toModel(u));
      setState({ data, isLoading: false });
    } catch {
      setState({ isLoading: false });
    }
  },
};

export const AssigneesStore = createRestStore<EmployeeView>({
  actions: assigneesActions,
  actionConfig,
  containerDisplayName: 'assignees-container',
  onInitAction: null,
});

export const useAssigneesData = createDataHook(AssigneesStore);
export const useAssigneesActions = createActionsHook(AssigneesStore);
